import styled from '@emotion/styled';

import AnimatedBox from './animated_box';

const AnswerBox = styled(AnimatedBox)`
  background: ${props => props.theme.foregroundColor};
  border-radius: 0.5rem;
  box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.5);
`;

export default AnswerBox;
